// extracted by mini-css-extract-plugin
module.exports = {"emptyBookList":"EmptyBookList__emptyBookList","emptyBookListText":"EmptyBookList__emptyBookListText"};